<template>
    <div>
        <b-container class="bv-example-row">
            <b-row cols="4" cols-sm="1" cos-md="2" cols-lg="4">
                <InfoLinkCard
                    title="Customers"
                    label="SignedUp"
                    :counter=cnt.customers
                    link="Customers"
                    :is-loading="isLoading"
                />
                <InfoLinkCard
                    title="Manage devices"
                    label="Operating devices"
                    :counter=cnt.devices
                    :is-loading="isLoading"
                    :route="operatingDevicesRoute"
                />
                <InfoLinkCard
                    title="ATS Licenses"
                    label="Active licenses"
                    :counter=cnt.ats_licenses
                    link="Licenses"
                    :is-loading="isLoading"
                />
                <InfoLinkCard
                    title="ATS3 Licenses"
                    label="Active licenses"
                    :counter=cnt.ats3_licenses
                    link="ATS3 licenses"
                    :is-loading="isLoading"
                />
            </b-row>

            <b-row class="border mx-0 my-3">
            </b-row>

            <b-row cols="2" cols-sm="1" cos-md="1" cols-lg="2">
                <device-warnings></device-warnings>
                <b-col cols="12" class="mt-3 mb-2">
                    <b-card>
                        <chart-title chart-title="Chart device by type"></chart-title>
                        <NothingToShow :is-loading="isLoading" :is-there-date="deviceByType.labels.length > 0">
                            <DoughnutChart
                                :chartData="deviceByType"
                                :width=200
                                :height=120
                            />
                        </NothingToShow>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-3 mb-2">
                    <b-card>
                        <chart-title chart-title="Chart device activity" class="mb-2"></chart-title>
                        <NothingToShow :is-loading="isLoading" :is-there-date="deviceActivity.labels.length > 0">
                            <DoughnutChart
                                :chartData="deviceActivity"
                                :width=200
                                :height=100
                                :max-legend-lable-lenght="35"
                                class="fix"
                                :label-links="deviceActivity.links"
                            />
                        </NothingToShow>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-3 mb-2">
                    <b-card>
                        <ChartFirmwareUpdateByDeviceType
                            :userDeviceTypes="deviceInfo"
                            :is-loading="isLoading"
                        />
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import InfoLinkCard from "../components/InfoLinkCard.vue";
import DoughnutChart from "./charts/DoughnutChart";

import {randomHexColorWithArray} from 'random-hex-color-generator';
import DeviceWarnings from "../components/DeviceWarnings.vue";
import ChartFirmwareUpdateByDeviceType from "../components/ChartFirmwareUpdateByDeviceType.vue";
import ChartTitle from "../components/ChartTitle.vue";
import NothingToShow from "../components/NothingToShow.vue";
import {RTStatesEnum} from "../../js/enums";

export default {
    name: "dashboard",
    components: {
        NothingToShow,
        ChartTitle,
        ChartFirmwareUpdateByDeviceType,
        DeviceWarnings,
        InfoLinkCard,
        DoughnutChart
    },
    data: () => ({
        chartConfiguration: {
            plugins: {
                legend: {
                    position: 'right'
                }
            }
        },
        isLoading: true,
        // counters
        cnt: {
            customers: 0,
            devices: 0,
            ats_licenses: 0,
            ats3_licenses: 0,
            isLoading: true,
            selected_state: []
        },
        // device by type
        deviceByType: {
            labels: [],
            datasets: []
        },
        deviceActivity: {
            labels: [],
            datasets: []
        },
        deviceTypes: [],
        deviceInfo: [],
    }),
    mounted() {
        Promise.all(
            [
                this.loadDashboardCountersData(),
                this.loadDashboardDeviceByTypeData(),
                this.loadDeviceActivityData(),
            ]
        ).finally(
            () => {
                this.isLoading = false;
            }
        );

    },
    methods: {
        loadDashboardCountersData() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/counters`;

            return axios.get(url).then(({data}) => {
                data = this.handleNullResponse(data);
                this.updateDashBoardCounters(data);
                return data;
            }).catch(e => {
                console.log(e);
            });
        },
        loadDashboardDeviceByTypeData() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/devices-by-type`;

            return axios.get(url).then(({data}) => {
                data = this.handleNullResponse(data);
                this.updateDeviceByType(data);
                return data;
            }).catch(e => {
                console.log(e);
            });
        },
        loadDeviceActivityData() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/devices-activity`;

            return axios.get(url).then(({data}) => {
                data = this.handleNullResponse(data);
                this.updateDeviceActivity(data);
                return data;
            }).catch(e => {
                console.log(e);
            });
        },
        updateDashBoardCounters(response) {
            this.cnt = Object.assign(this.cnt, response.data);
            this.cnt.isLoading = false;
        },
        handleNullResponse(response) {
            if (!response) {
                response = {};
            }
            if (!response.data)
                response.data = [];
            return response;
        },

        updateDeviceByType(response) {
            this.deviceTypes = _.map(response.data, 'commercial_name');

            this.deviceInfo = response.data;

            // this.deviceIds = _.map(response.data, 'id');
            this.deviceByType = {
                labels: _.map(response.data, 'commercial_name'),
                datasets: [
                    {
                        data: _.map(response.data, 'percentage'),
                        backgroundColor: randomHexColorWithArray(response.data.length + 1),
                    }
                ]
            };
        },

        updateDeviceActivity(response) {
            this.deviceActivity = {
                labels: response.data.map(({label, labelCount}) => this.$tc(label, labelCount, {labelCount})),
                datasets: [
                    {
                        // backgroundColor: randomHexColorWithArray(response.data.length+1),
                        backgroundColor: [
                            "#03e243",
                            "#aab400",
                            "#ed5e10",
                            "#f22149",
                        ],
                        data: _.map(response.data, 'percentage'),
                    }
                ],
                links: response.data.map(activity => {
                    return this.$router.resolve({
                        name: 'Manage devices',
                        query: {
                            rt_device_activity: activity.id,
                            selected_state: activity.selected_state?.length
                                ? activity.selected_state.join(',')
                                : RTStatesEnum.DISMESSO
                        }
                    }).href;
                })
            }
        },
    },
    computed: {
        operatingDevicesRoute() {
            const selectedState = this.cnt.selected_state || [];

            return selectedState?.length
                ? { name: 'DevicesContainer', query: { selected_state: selectedState.join(',') }}
                :{ name: 'DevicesContainer'}
        }
    }
}
</script>


<style scoped>
.fix {
    margin-top: 80px;
    margin-bottom: 20px;
}

.chat-place-holder {
    text-align: center;
    padding: 120px 0;

}
</style>
